import { useEffect, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';

const useFirestoreCount = (targetQuery, enabled = true) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const queries = Array.isArray(targetQuery)
      ? targetQuery.filter(Boolean)
      : (targetQuery ? [targetQuery] : []);

    if (!enabled || queries.length === 0) {
      setCount(0);
      return undefined;
    }

    const snapshotsByIndex = new Map();
    const updateCount = () => {
      const docIds = new Set();

      snapshotsByIndex.forEach((snapshot) => {
        snapshot.docs.forEach((doc) => {
          docIds.add(doc.id);
        });
      });

      setCount(docIds.size);
    };

    const unsubscribes = queries.map((queryRef, index) => onSnapshot(queryRef, (snapshot) => {
      snapshotsByIndex.set(index, snapshot);
      updateCount();
    }));

    return () => {
      unsubscribes.forEach((unsubscribe) => unsubscribe());
    };
  }, [enabled, targetQuery]);

  return count;
};

export default useFirestoreCount;
